module.exports = __webpack_public_path__ + "img/sel_Chengdu.2649acaa.png";